import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private _snackBar = inject(MatSnackBar);

  showSuccess(message: string): void {
    this._snackBar.open(message, '', {
      duration: 3000,
      panelClass: 'success',
    });
  }

  showError(message: string): void {
    this._snackBar.open(message, '', {
      duration: 3000,
      panelClass: 'error',
    });
  }

  showInfo(message: string): void {
    this._snackBar.open(message, '', {
      duration: 3000,
      panelClass: 'info',
    });
  }
}
